import { CardId } from '../app/types';

export const cardStartDomRegistry: Partial<Record<CardId, DOMRect>> = {};

export function clearDomRegistries(): void {
    Object.keys(cardStartDomRegistry).forEach((key) => {
        delete cardStartDomRegistry[key as CardId];
    });
}
